import React, { Component } from "react";
import {
  Header,
  Icon,
  Form,
  Grid,
  Message
} from "semantic-ui-react";

const style = {
  NewForm: {
    textAlign: "left"
  }
};

function validateEmail(email) {
  var reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return reg.test(email);
}

function checkForm(name, email, tel){
  var errorList = [];

  if(!name){
    errorList.push("Name cannot be empty");
  }

  if(!email){
    errorList.push("Email cannot be empty");
  }else if(!validateEmail(email)){
    errorList.push("Invalid email");
  }

  return errorList;
}

export default class BookNewForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formError: []
    };

    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  handleFormSubmit(e) {
    var errorList = checkForm(this.props.name, this.props.email, this.props.telephone);
    if(errorList.length === 0){
      this.setState({ formError: [] });
      this.props.onNext();
    }else{
      this.setState({ formError: errorList });
    }
  }

  render() {
    var errorMassage = null;
    if(this.state.formError.length !== 0){
      errorMassage = (
        <Message
          error
          header='Error'
          list={this.state.formError}
        />
      );
    }

    return (
      <Grid centered>
        <Grid.Row>
          <Header as="h1" content="New Book" />
        </Grid.Row>
        <Grid.Row computer="12">
          <Form
            style={style.NewForm}
            size="large"
            onSubmit={this.handleFormSubmit}
            error={this.state.formError.length !== 0}
          >
            <Form.Input
              label="Name"
              placeholder="firstname lastname"
              value={this.props.name}
              onChange={this.props.handleNameChange}
            />
            <Form.Input
              label="Email Address"
              iconPosition="left"
              placeholder="jane@mail.com"
              value={this.props.email}
              onChange={this.props.handleEmailChange}
            >
              <Icon name="at" />
              <input />
            </Form.Input>
            <Form.Input
              label="Telephone Number (Optional)"
              placeholder="401123456"
              value={this.props.telephone}
              onChange={this.props.handleTelChange}
            />
            {errorMassage}
            <Form.Button primary fluid>
              Next
            </Form.Button>
          </Form>
        </Grid.Row>
      </Grid>
    );
  }
}
